import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalServiceService {

  constructor(private modalService: NgbModal) {}

  openModal(component: any, modalData?: any): NgbModalRef {
    const modalRef = this.modalService.open(component, { size: 'md', centered: true ,backdrop:'static'});
    if (modalData) {
      modalRef.componentInstance.data = modalData; 
    }
    return modalRef;
  }
  openLgModal(component: any, modalData?: any): NgbModalRef  {
    const modalRef = this.modalService.open(component, { size: 'lg', centered: true,backdrop:'static' });
    if (modalData) {
      modalRef.componentInstance.data = modalData; 
    }
    return modalRef;
  }
}
